if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      // Agregado: bandera para saber si ya se ha interactuado con la selección
      this.hasUserChanged = false;
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      // Ajuste pdp_block_disabled_options (snippets/mkt-store-config.liquid): las opciones no disponibles no se pueden elegir
      this.addEventListener('click', this.onDisabledOptionClick.bind(this), true);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });
      this.productWrapper = this.closest('.thb-product-detail');
      if (this.productWrapper) {
        this.productSlider = this.productWrapper.querySelector(`#MediaGallery-${this.dataset.section}`);
        this.hideVariants = this.productSlider.dataset.hideVariants === 'true';
      }
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
      // Si la variante seleccionada por defecto (por ?variant= en la URL, o por
      // ser la primera del array) está agotada, su swatch queda oculto vía
      // .is-disabled pero seguía marcada como "checked": el formulario
      // (precio, id oculto, stock) apuntaba a una variante invisible e
      // inagotable de seleccionar manualmente. Se reubica en la primera
      // opción disponible de cada fieldset antes de pintar nada más.
      this.selectFirstAvailableVariant();
      this.revealVariantPicker();
      this.setImageSet();
      // Al cargar la ficha, se actualizan los metafields de la variante por defecto
      this.updateMetafields();
      this.updateProductTitle();
    }

    // Marca el selector como listo: el CSS de las tiendas que ocultan los valores sin stock (input.is-disabled)
    // solo lo hace cuando existe .variant-selects--ready, para no mostrar un instante opciones no válidas.
    revealVariantPicker() {
      this.classList.remove('variant-selects--pending');
      this.classList.add('variant-selects--ready');
    }

    selectFirstAvailableVariant() {
      if (this.isDisabledFeature != 'true') return;
      if (this.currentVariant && this.currentVariant.available) return;

      let changed = false;
      this.fieldsets.forEach((fieldset) => {
        const select = fieldset.querySelector('select');
        if (select) {
          const selectedOption = select.options[select.selectedIndex];
          if (selectedOption && selectedOption.disabled) {
            const availableOption = Array.from(select.options).find((option) => !option.disabled);
            if (availableOption) {
              select.value = availableOption.value;
              changed = true;
            }
          }
          return;
        }
        const checkedInput = fieldset.querySelector('input:checked');
        if (checkedInput && checkedInput.classList.contains('is-disabled')) {
          const availableInput = fieldset.querySelector('input:not(.is-disabled)');
          if (availableInput) {
            availableInput.checked = true;
            changed = true;
          }
        }
      });

      if (!changed) return;

      this.updateOptions();
      this.updateMasterId();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.theme.variantStrings.unavailable, true);
        this.setUnavailable();
        return;
      }

      this.updateMedia();
      if (this.updateUrl) {
        this.updateURL();
      }
      this.updateVariantInput();
      this.renderProductInfo();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    onDisabledOptionClick(event) {
      if (!(window.mktPdp && window.mktPdp.blockDisabledOptions)) return;
      const label = event.target.closest('label');
      let input = event.target.closest('input, option, select');
      if (!input && label && label.htmlFor) {
        input = document.getElementById(label.htmlFor);
      }
      if (!input) return;
      const isDisabledInput = input.classList && input.classList.contains('is-disabled');
      const isDisabledOption = input.tagName === 'OPTION' && input.disabled;
      if (isDisabledInput || isDisabledOption) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    // Si la combinación resultante no existe o está agotada, se reubica en la
    // variante disponible más cercana conservando la opción que acaba de tocar
    // el usuario (p. ej. Base de carga -> Maia dejaba un color que ya no
    // correspondía a una variante con stock).
    adjustToAvailableVariant(changedIndex) {
      if (this.currentVariant && (this.currentVariant.available || this.isDisabledFeature != 'true')) return;
      if (changedIndex < 0 || !this.fieldsets) return;

      const changedValue = this.options[changedIndex];
      let best = null;
      let bestScore = -1;
      this.getVariantData().forEach((variant) => {
        if (!variant.available || variant.options[changedIndex] !== changedValue) return;
        // Se prioriza coincidir con las opciones previas (las más significativas)
        let score = 0;
        variant.options.forEach((value, i) => {
          if (i !== changedIndex && value === this.options[i]) score += 1 << (variant.options.length - i);
        });
        if (score > bestScore) {
          best = variant;
          bestScore = score;
        }
      });
      if (!best) return;

      this.fieldsets.forEach((fieldset, i) => {
        const value = best.options[i];
        const select = fieldset.querySelector('select');
        if (select) {
          select.value = value;
          return;
        }
        const input = Array.from(fieldset.querySelectorAll('input')).find((el) => el.value === value);
        if (input) input.checked = true;
      });
      this.updateOptions();
      this.updateMasterId();
    }

    onVariantChange(event) {
      this.updateOptions();
      this.updateMasterId();
      const changedFieldset = event && event.target && event.target.closest ? event.target.closest('fieldset') : null;
      this.adjustToAvailableVariant(changedFieldset ? this.fieldsets.indexOf(changedFieldset) : -1);
      this.toggleAddButton(true, window.theme.variantStrings.loading, false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, window.theme.variantStrings.unavailable, true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateMetafields();
        this.updateProductTitle();
        //this.updateShareUrl();
      }
      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });

      // Se ejecuta el bloque de actualización de información sólo cuando ya hubo interacción del usuario
      if (this.hasUserChanged) {
        var final_variant_value = '';
        var variant_names = document.getElementsByClassName('m_titlee');
        const elements_hide = document.querySelectorAll('.custom_div');
        const textElement = document.querySelector('.dp-energy-efficiency-badge-rating-border');
        var variant_meta_values = document.getElementsByClassName('meta_value');
        for (var i = 0; i < variant_names.length; i++) {
          if (this.currentVariant && variant_names[i].innerHTML.trim() == this.currentVariant.title.trim()) {
            final_variant_value = variant_meta_values[i].innerHTML;
          }
        }
        // textElement solo existe en productos con badge de eficiencia energetica configurado;
        // en el resto es null y escribirle textContent directamente rompia el cambio de variante.
        if (textElement) {
          textElement.textContent = final_variant_value;
        }
        elements_hide.forEach(element => {
          if (final_variant_value) {
            element.classList.remove('hidden');
          } else {
            element.classList.add('hidden');
          }
        });
      } else {
        // Se marca que ya hubo una interacción para futuras actualizaciones
        this.hasUserChanged = true;
      }
    }

    updateMetafields() {
      if (typeof variantMetafields === 'undefined' || !this.currentVariant) return;

      const currentMetafield = variantMetafields.find(metafield => metafield.id == this.currentVariant.id);
      if (!currentMetafield) return;

      const heightContainer = document.querySelector('.variant_height');
      const heightSpan = document.querySelector('.height-text');
      const widthContainer = document.querySelector('.variant_width');
      const widthSpan = document.querySelector('.width-text');
      const lengthContainer = document.querySelector('.variant_length');
      const lengthSpan = document.querySelector('.length-text');

      if (heightContainer && heightSpan) {
        if (currentMetafield.height) {
          heightContainer.style.display = 'flex';
          heightSpan.innerText = currentMetafield.height;
        } else {
          heightContainer.style.display = 'none';
        }
      }

      if (widthContainer && widthSpan) {
        if (currentMetafield.width) {
          widthContainer.style.display = 'flex';
          widthSpan.innerText = currentMetafield.width;
        } else {
          widthContainer.style.display = 'none';
        }
      }

      if (lengthContainer && lengthSpan) {
        if (currentMetafield.length) {
          lengthContainer.style.display = 'flex';
          lengthSpan.innerText = currentMetafield.length;
        } else {
          lengthContainer.style.display = 'none';
        }
      }
    }

    updateProductTitle() {
      if (!this.currentVariant) return;

      const titleEl = document.getElementById(`ProductTitle-${this.dataset.section}`)
        || this.productWrapper?.querySelector('.product-title');
      const stickyTitleEl = document.querySelector('.product-add-to-cart-sticky--title');
      const titlesDataEl = document.getElementById(`VariantCustomTitles-${this.dataset.section}`);

      let customTitle = null;
      if (titlesDataEl) {
        try {
          const titles = JSON.parse(titlesDataEl.textContent);
          customTitle = titles[this.currentVariant.id];
        } catch (e) {
          customTitle = null;
        }
      }

      const defaultTitle = titleEl?.dataset.defaultTitle
        || stickyTitleEl?.dataset.defaultTitle
        || '';
      const displayTitle = (customTitle && String(customTitle).trim()) ? customTitle : defaultTitle;

      if (displayTitle) {
        if (titleEl) {
          titleEl.textContent = displayTitle;
        }
        if (stickyTitleEl) {
          stickyTitleEl.textContent = displayTitle;
        }

        const wishlistBtn = this.productWrapper?.querySelector('.wishlist-btn-product-page');
        if (wishlistBtn) {
          wishlistBtn.setAttribute('data-product-title', displayTitle);
        }
      }

      this.updateStickyOptions();
    }

    updateStickyOptions() {
      const stickyOptionsEl = document.querySelector('.product-add-to-cart-sticky--options');
      if (!stickyOptionsEl || !this.currentVariant || stickyOptionsEl.hasAttribute('data-disabled')) return;
      const options = (this.currentVariant.options || []).filter((value) => value && value !== 'Default Title');
      stickyOptionsEl.textContent = options.join(stickyOptionsEl.dataset.separator || ' · ');
      stickyOptionsEl.toggleAttribute('hidden', options.length === 0);
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.option_keys = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.querySelector('select')) {
          this.options.push(fieldset.querySelector('select').value);
          this.option_keys.push(fieldset.querySelector('select').name);
        } else if (fieldset.querySelectorAll('input').length) {
          this.option_keys.push(fieldset.querySelector('input').name);
          this.options.push(fieldset.querySelector('input:checked').value);
        }
      });
      this.dataset.options = this.options;
    }

    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        let label = item.querySelector('.form__label__value');
        if (label) {
          label.innerHTML = this.options[i];
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value="${option}"]`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        this.other[0].setDisabled();
        this.other[0].setImageSetMedia();
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      if (!this.productSlider) return;
      let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
      let activeMedia = this.productSlider.querySelector(`[data-media-id="${mediaId}"]`);

      this.productSlider.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });

      this.setImageSetMedia();

      if (!activeMedia) return;

      activeMedia.classList.add('is-active');

      activeMedia.parentElement.prepend(activeMedia);

      window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: 0,
          top: 0,
          behavior: 'smooth'
        });
      });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (!input) {
          console.error("❌ Error: No se encontró el input[name='id']");
          return;
        }
        input.value = this.currentVariant ? this.currentVariant.id : "";
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`, `delivery-info-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      const isB2B = window.WSAIO && typeof WSAIO.isWholesaleCustomer === 'function' && WSAIO.isWholesaleCustomer();
      const priceEl = document.getElementById(`price-${this.dataset.section}`);
      // Solo si el puente del tema (wholesale-all-in-one.liquid) está activo: es quien devuelve la opacidad. Con el app embed (IT, UK, USA)
      // o Wholesale nativo (MX) no hay puente y el precio se quedaba invisible tras cambiar de variante.
      if (isB2B && priceEl && window.mktWsaioPriceBridge) priceEl.style.opacity = '0';

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);
            if (source && destination) destination.innerHTML = source.innerHTML;
            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');
            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');
          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
          document.dispatchEvent(new CustomEvent('wsaio:price-updated', {
            detail: {
              variantId: this.currentVariant.id,
              sectionId: this.dataset.section
            }
          }));
        });
    }

    toggleAddButton(disable = false, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      // Acotado a [data-section]: con el quick-view de "shop the look" puede haber
      // varios formularios de producto en el DOM a la vez, y un selector global
      // deshabilitaba/renombraba también los botones de otros productos.
      const submitButtons = document.querySelectorAll(`[data-section="${this.dataset.section}"] .single-add-to-cart-button`);
      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButtonText) return;
        submitButton.classList.remove('loading');
        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          submitButtonText.textContent = text || window.theme.variantStrings.soldOut;
        } else {
          submitButton.removeAttribute('disabled');
          submitButtonText.textContent = window.theme.variantStrings.addToCart;
        }
        if (modifyClass) {
          submitButton.classList.toggle('sold-out', disable);
        }
      });
    }

    setUnavailable() {
      // Ver comentario en toggleAddButton: acotado a [data-section] para no afectar
      // a botones de otros productos (p.ej. quick-view abierto sobre otra ficha).
      const submitButtons = document.querySelectorAll(`[data-section="${this.dataset.section}"] .single-add-to-cart-button`);
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        if (submitButtonText) submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.setAttribute('disabled', 'disabled');
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();
      if (variant_data && this.currentVariant) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          var isOne = false;
          const fieldset_options = Object.values(available_options)[i];
          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              let fieldset3 = Object.values(available_options)[2];
              if (fieldset3.length === 1) {
                isOne = true;
              }
              if (i === 1 && fieldset3.some(option => !option.isUnavailable) && isOne === true) {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              } else if (i === 1) {
                return;
              } else {
                fieldset.querySelectorAll('input').forEach((input, input_i) => {
                  input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
                });
              }
            }
          }
        });
      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }
      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productSlider.querySelectorAll(`[data-set-name="${this.imageSetName}"]`);
      if (this.hideVariants) {
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      } else {
        let set_images = Array.from(selected_set_images).filter(function (element) {
          return element.dataset.group === group;
        });
        set_images.forEach(thumb => {
          thumb.parentElement.prepend(thumb);
        });
      }
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      return variant_data.reduce((options, variant) => {
        Object.keys(options).forEach(index => {
          if (variant[index] === null) return;
          let entry = options[index].find(option => option.value === variant[index]);
          if (typeof entry === 'undefined') {
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, { value, index }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });
        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }
  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.pagination = this.parentElement.querySelector('.product-images-buttons');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      let observer = new MutationObserver(() => {
        this.setupProductGallery();
      });
      observer.observe(this, {
        attributes: true,
        attributeFilter: ['class'],
        childList: true,
        characterData: false
      });
      this.setupProductGallery();
      this.setupShowMore();
      this.watchGridSlides();
      if (this.pagination) {
        this.setupPagination();
        this.addEventListener('scroll', this.updatePagination.bind(this));
        const resizeObserver = new ResizeObserver(entries => this.onPaginationResize());
        resizeObserver.observe(this);
      }
    }
    // Layout grid: las N primeras imágenes van grandes y las de la 11ª en adelante se ocultan.
    // Se cuenta solo imágenes, no el nº de hijos: la app de variantes deja n vídeos/3D en el DOM
    // antes que las imágenes y desplazaría un nth-child.
    // Observer propio, solo childList (no attributes) y con rAF + firma del orden: la app de
    // variantes reordena con appendChild, y así nunca retroalimentamos otros observers.
    watchGridSlides() {
      if (!this.classList.contains('product-images--grid')) return;
      let scheduled = false;
      let lastSignature = null;
      const run = () => {
        scheduled = false;
        // Incluye hidden + display inline (app de variantes) e is-active de data-group (hide_variants del tema)
        const signature = Array.from(this.children, (slide) => {
          const hidden = slide.hidden || slide.style.display === 'none' ? 'h' : '';
          const active = slide.hasAttribute('data-group') && slide.classList.contains('is-active') ? 'a' : '';
          return slide.id + hidden + active;
        }).join('|');
        if (signature === lastSignature) return;
        lastSignature = signature;
        this.tagGridSlides();
      };
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(run);
      }).observe(this, { childList: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
      // La app de galería / cambio de variante puede ocultar fotos un instante después
      document.addEventListener('product:variant-change', () => {
        lastSignature = null;
        scheduled = true;
        requestAnimationFrame(run);
        // Segundo pase: apps de galería por variante suelen filtrar de forma async
        setTimeout(() => {
          lastSignature = null;
          this.tagGridSlides();
        }, 150);
      });
      run();
    }
    isSlideVisibleForGrid(slide) {
      if (slide.hidden || slide.style.display === 'none') return false;
      // hide_variants del tema: slides con data-group solo se muestran si son is-active
      const gallery = this.closest('[data-hide-variants="true"]');
      if (gallery && slide.hasAttribute('data-group') && !slide.classList.contains('is-active')) {
        return false;
      }
      return true;
    }
    tagGridSlides() {
      let position = 0;
      let overflowCount = 0;
      this.querySelectorAll(':scope > .product-images__slide').forEach((slide) => {
        const isImage = slide.classList.contains('product-images__slide--image');
        const isVisible = this.isSlideVisibleForGrid(slide);
        if (isImage && isVisible) position++;
        const isOverflow = isImage && isVisible && position >= 11;
        slide.classList.toggle('is-grid-large', isImage && isVisible && position <= 6);
        slide.classList.toggle('is-grid-overflow', isOverflow);
        if (isOverflow) overflowCount++;
      });
      this.classList.add('is-grid-tagged');
      this.updateShowMoreButton(overflowCount);
    }
    updateShowMoreButton(overflowCount) {
      if (this.classList.contains('is-gallery-expanded')) return;
      const container = this.closest('.product-image-container') || this.parentElement;
      const wrap = container && container.querySelector('.product-images__show-more-wrap');
      const button = (wrap && wrap.querySelector('[data-product-images-show-more]'))
        || (container && container.querySelector('[data-product-images-show-more]'))
        || this.querySelector('[data-product-images-show-more]');
      const hasMore = overflowCount > 0;

      this.classList.toggle('product-images--has-more', hasMore);

      if (wrap) {
        wrap.hidden = !hasMore;
        wrap.style.display = hasMore ? '' : 'none';
      }
      if (!button) return;
      if (!hasMore) {
        button.hidden = true;
        return;
      }
      button.hidden = false;
      const template = button.dataset.labelTemplate;
      if (template) {
        button.textContent = template.replace('__COUNT__', String(overflowCount));
      }
    }
    setupShowMore() {
      const container = this.closest('.product-image-container') || this.parentElement;
      const button = (container && container.querySelector('[data-product-images-show-more]'))
        || this.querySelector('[data-product-images-show-more]');
      if (!button) return;
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.classList.add('is-gallery-expanded');
        if (container) container.classList.add('is-gallery-expanded');
        button.setAttribute('aria-expanded', 'true');
        const wrap = button.closest('.product-images__show-more-wrap');
        if (wrap) {
          wrap.remove();
        } else {
          button.remove();
        }
      });
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems(activeImages) {
      let images = activeImages.map((item) => {
        let activelink = item.querySelector('.product-single__media-zoom');
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h,
          title: activelink.getAttribute('title')
        };
      });
      return images;
    }
    setEventListeners() {
      let captionEl = this.dataset.captions,
        pswpElement = document.querySelectorAll('.pswp')[0],
        options = {
          maxSpreadZoom: 2,
          loop: false,
          allowPanToNext: false,
          closeOnScroll: false,
          showHideOpacity: false,
          arrowKeys: true,
          history: false,
          captionEl: captionEl,
          fullscreenEl: false,
          zoomEl: false,
          shareEl: false,
          counterEl: true,
          arrowEl: true,
          preloaderEl: true
        };
      let openPswp = (e, link, options, pswpElement) => {
        let activeImages = Array.from(this.querySelectorAll('.product-images__slide--image')).filter(element => element.clientWidth > 0),
          items = this.buildItems(activeImages),
          parent = link.closest('.product-images__slide'),
          i = activeImages.indexOf(parent);
        options.index = parseInt(i, 10);
        options.getThumbBoundsFn = () => {
          const thumbnail = link.closest('.product-single__media'),
            pageYScroll = window.scrollY || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        };
        if (typeof PhotoSwipe !== 'undefined') {
          let pswp = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
          pswp.listen('firstUpdate', () => {
            pswp.listen('parseVerticalMargin', function (item) {
              item.vGap = {
                top: 50,
                bottom: 50
              };
            });
          });
          pswp.init();
        }
        e.preventDefault();
      };
      this.querySelectorAll('.product-single__media-zoom').forEach(function (link) {
        if (link.dataset.galleryBound === 'true') return;
        let thumbnail = link.closest('.product-single__media');
        let clone = link.cloneNode(true);
        clone.dataset.galleryBound = 'true';
        thumbnail.append(clone);
        link.remove();
        clone.addEventListener('click', (e) => openPswp(e, clone, options, pswpElement));
      });
    }
    setupPagination() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.currentPageElement = this.pagination.querySelector('.slider-counter--current');
      this.pageTotalElement = this.pagination.querySelector('.slider-counter--total');
      this.prevButton = this.pagination.querySelector('button[name="previous"]');
      this.nextButton = this.pagination.querySelector('button[name="next"]');
      this.prevButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onPaginationButtonClick.bind(this));
      this.updatePagination();
    }
    onPaginationResize() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    }
    onPaginationButtonClick(event) {
      event.preventDefault();
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.scrollLeft + (1 * this.sliderItemOffset) : this.scrollLeft - (1 * this.sliderItemOffset);
      this.scrollTo({ left: this.slideScrollPosition });
    }
    updatePagination() {
      if (!this.nextButton) return;
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.scrollLeft / this.sliderItemOffset) + 1;
      if (this.currentPageElement) {
        this.currentPageElement.textContent = this.currentPage;
      }
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1]
          }
        }));
      }
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.clientWidth + this.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.scrollLeft;
    }
  }
  customElements.define('product-slider', ProductSlider);
}

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name=id]').disabled = false;
      // Un único listener de submit por formulario. Cualquier <product-form> con el mismo
      // data-section (p. ej. las recomendaciones que inyecta plus-carousel-recommendations.js
      // con innerHTML) resuelve este mismo formulario por id y añadía un segundo listener:
      // un clic enviaba dos POST /cart/add.
      if (!this.sticky && !this.form.__productFormSubmitBound) {
        this.form.__productFormSubmitBound = true;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (!this.form.reportValidity()) {
        return;
      }
      // Ver comentario en toggleAddButton (VariantSelects): acotado a [data-section]
      // para no poner en "loading" botones de otros productos abiertos a la vez.
      const submitButtons = document.querySelectorAll(`[data-section="${this.dataset.section}"] .single-add-to-cart-button`);
      submitButtons.forEach((submitButton) => {
        if (submitButton.classList.contains('loading')) return;
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
      });
      this.handleErrorMessage();
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };
      let formData = new FormData(this.form);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            dispatchCustomEvent('product:variant-error', {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.description,
              message: response.message
            });
            this.handleErrorMessage(response.description);
            return;
          }
          this.renderContents(response);
          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButtons.forEach((submitButton) => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
          });
        });
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        // parsedState.sections puede venir incompleto (respuesta de /cart/add truncada,
        // extensión de terceros interceptando el fetch, etc.); sin esta guarda,
        // parsedState.sections[section.section] revienta con "Cannot read properties of
        // undefined" y deja el resto del carrito sin actualizar.
        const sectionHTML = parsedState.sections && parsedState.sections[section.section];
        if (!sectionHTML) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));
      let product_drawer = document.getElementById('Product-Drawer');
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.querySelector('.product-quick-images--container').classList.remove('active');
        document.body.classList.remove('open-quick-view');
        if (window.innerWidth < 1069) {
          product_drawer.classList.remove('active');
          if (document.getElementById('Cart-Drawer')) {
            document.getElementById('Cart-Drawer').classList.add('active');
            document.body.classList.add('open-cart');
            document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
            dispatchCustomEvent('cart-drawer:open');
          }
        } else {
          product_drawer.querySelector('.product-quick-images--container').addEventListener('transitionend', function () {
            product_drawer.classList.remove('active');
            if (document.getElementById('Cart-Drawer')) {
              document.getElementById('Cart-Drawer').classList.add('active');
              document.body.classList.add('open-cart');
              document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full').classList.add('active');
              dispatchCustomEvent('cart-drawer:open');
            }
          });
        }
        if (!document.getElementById('Cart-Drawer')) {
          document.body.classList.remove('open-cc');
        }
      } else if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.body.classList.add('open-cart');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();
      this._teleporting = false;
    }
    connectedCallback() {
      if (this.parentElement !== document.body) {
        this._teleporting = true;
        document.body.appendChild(this);
        return;
      }
      this._teleporting = false;
      this.setupObservers();
      this.setupMetaScroll();
      this.setupResize();
    }
    disconnectedCallback() {
      if (this._teleporting) return;
      this.teardown();
    }
    teardown() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
      if (this._footerObserver) {
        this._footerObserver.disconnect();
        this._footerObserver = null;
      }
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      document.body.classList.remove('sticky-atc-visible');
      document.documentElement.style.setProperty('--sticky-atc-offset', '0px');
    }
    setupResize() {
      if (this._resizeObserver) return;
      this._resizeObserver = new ResizeObserver(() => this.updateOffset());
      this._resizeObserver.observe(this);
    }
    setupMetaScroll() {
      const meta = this.querySelector('[data-sticky-scroll-to-variants]');
      if (!meta || meta.dataset.scrollBound === '1') return;
      meta.dataset.scrollBound = '1';
      meta.addEventListener('click', () => {
        const target = document.getElementById(`variant-selects-${this.dataset.section}`);
        if (!target) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'center'
        });
      });
    }
    setStickyVisible(visible) {
      this.classList.toggle('sticky--visible', visible);
      this.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('sticky-atc-visible', visible);
      this.updateOffset();
    }
    updateOffset() {
      const visible = this.classList.contains('sticky--visible');
      const height = visible ? Math.ceil(this.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--sticky-atc-offset', `${height}px`);
    }
    setupObservers() {
      if (this._observer) return;
      let _this = this,
        form = document.getElementById(`product-form-${this.dataset.section}`),
        footer = document.getElementById('footer'),
        ngfContainer = document.querySelector('.ngf__container');

      _this.formPassed = false;
      _this.isFooterVisible = false;

      let observer = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.target === footer || entry.target === ngfContainer) {
            if (entry.isIntersecting || entry.intersectionRatio > 0) {
              _this.setStickyVisible(false);
            } else if (!entry.isIntersecting && _this.formPassed && !_this.isFooterVisible) {
              _this.setStickyVisible(true);
            }
          }
          if (entry.target === form) {
            let boundingRect = form.getBoundingClientRect();
            if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top + boundingRect.height)) {
              _this.formPassed = true;
              if (!_this.isFooterVisible) {
                _this.setStickyVisible(true);
              }
            } else if (entry.intersectionRatio === 1) {
              _this.formPassed = false;
              _this.setStickyVisible(false);
            }
          }
        });
      }, {
        threshold: [0, 0.1, 0.5, 1]
      });

      const footerObserver = new IntersectionObserver(function (entries) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            _this.isFooterVisible = true;
            _this.setStickyVisible(false);
          } else {
            const footerRect = footer ? footer.getBoundingClientRect() : null;
            const ngfRect = ngfContainer ? ngfContainer.getBoundingClientRect() : null;
            const footerOutOfView = !footerRect || footerRect.top > window.innerHeight;
            const ngfOutOfView = !ngfRect || ngfRect.top > window.innerHeight;

            if (footerOutOfView && ngfOutOfView && _this.formPassed) {
              _this.isFooterVisible = false;
              _this.setStickyVisible(true);
            }
          }
        });
      }, {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      });

      this._observer = observer;
      this._footerObserver = footerObserver;

      if (form) observer.observe(form);
      if (footer) {
        observer.observe(footer);
        footerObserver.observe(footer);
      }
      if (ngfContainer) {
        observer.observe(ngfContainer);
        footerObserver.observe(ngfContainer);
      }
    }
  }
  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }
  customElements.define('side-panel-links', ProductSidePanelLinks);
}

if (!customElements.get('short-description-block')) {
  class ShortDescriptionBlock extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector('.product-short-description-block__text');
      this.toggle = this.querySelector('.product-short-description-block__toggle');
      if (!this.text || !this.toggle) return;

      // Solo mostrar el botón "Ver más" si el texto realmente se corta con el clamp de CSS.
      requestAnimationFrame(() => {
        if (this.text.scrollHeight > this.text.clientHeight + 1) {
          this.toggle.classList.add('is-visible');
        }
      });

      this.toggle.addEventListener('click', () => {
        const expanded = this.text.classList.toggle('is-expanded');
        this.toggle.classList.toggle('is-visible', !expanded);
      });
    }
  }
  customElements.define('short-description-block', ShortDescriptionBlock);
}

if (typeof addIdToRecentlyViewed !== "undefined") {
  addIdToRecentlyViewed();
}

// Envolver en IIFE para evitar conflictos de scope y solo ejecutar en páginas de producto
(function () {
  'use strict';

  // Engancha el filtrado dinámico de combinaciones (deshabilita/oculta opciones
  // incompatibles y reselecciona la primera disponible) al <variant-selects> que
  // haya dentro de `root`. Se llama una vez al cargar la página y también cada vez
  // que el quick-view de "shop the look" inyecta su propio picker por AJAX: ese
  // picker no existe todavía cuando este script corre por primera vez, así que sin
  // volver a engancharlo aquí se queda sin ningún filtrado de variantes.
  function setupVariantAvailabilityFilter(root) {
    const variantSelects = root.querySelector('variant-selects') || root.querySelector('variant-radios');

    if (!variantSelects || variantSelects.dataset.availabilityFilterBound === 'true') {
      return;
    }

    const pickerType = (variantSelects.querySelectorAll('fieldset').length > 0) ? 'radios' : 'selects';
    const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
    const productJsonElement = variantSelects.querySelector('[type="application/json"]');
    if (!productJsonElement) {
      // Silenciar el warning
      return;
    }

    let productJson, selectedOptions = [];

    function validCombo(inputValue, optionLevel) {
      if (!productJson || !selectedOptions || !selectedOptions.length) {
        return false;
      }
      for (let i = 0; i < productJson.length; i++) {
        if (optionLevel == 1) {
          if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) { return true; }
        } else {
          if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) { return true; }
        }
      }
      return false;
    }

    function rebuildOptions() {
      if (!variantSelects || !fieldsets || !productJson) {
        return;
      }
      selectedOptions = fieldsets.map((fieldset) => {
        return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
      });
      for (let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
        const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');
        inputs.forEach(input => {
          input.disabled = (validCombo(input.value, optionLevel)) ? false : true;
          if (pickerType == 'radios') {
            const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);
            label.style.display = (input.disabled) ? "none" : "";
          } else {
            input.hidden = (validCombo(input.value, optionLevel)) ? false : true;
          }
        });
      }
      for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
        if (pickerType == 'radios') {
          if (fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
            change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
          }
        } else {
          if (fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
            change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
          }
        }
        if (change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    try {
      productJson = JSON.parse(productJsonElement.textContent);
    } catch (e) {
      // Silenciar errores de parsing
      return;
    }

    variantSelects.dataset.availabilityFilterBound = 'true';
    variantSelects.addEventListener('change', rebuildOptions);
    rebuildOptions();
  }

  setupVariantAvailabilityFilter(document);

  document.addEventListener('quick-view:open', function () {
    const drawerContent = document.getElementById('Product-Drawer-Content');
    if (drawerContent) setupVariantAvailabilityFilter(drawerContent);
  });
})(); // Cerrar IIFE


$(document).on("click", "quick-view", function () {
  const sidePanel = $(".side-panel-inner");
  sidePanel.css("position", "relative").append(`
        <div class="loader-overlay">
            <div class="loader"></div>
        </div>
    `);
  sidePanel.css("opacity", "0.5");
  setTimeout(() => {
    sidePanel.css("opacity", "1");
    sidePanel.find(".loader-overlay").remove();
  }, 2000);
});




